import React, { useEffect, useState } from 'react';
import ImProLogo from '../../../assets/svg/inversum-logo.svg';
import { UserInfo } from '../../features/userProfile/userInfo/userInfo';
import { LanguageSelect } from '../../features/Languages/LanguageSelect';
import { FlexCenter } from '../FlexCenter/FlexCenter';
import { Navbar } from '../../features/Navbar/Navbar';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../constants/constants';
import { title } from 'process';
import { ProjectPathIcon } from '../../features/TreeComposite/TreeWidget/ProjectPathIcon';
import { Title } from '../../ui/Title';
import { FlexBetween } from '../FlexBetween/FlexBetween';
import { SpacingCustom } from '../Spacing/SpacingCustom';
import { ListHeader } from '../ListHeader/ListHeader';
import { MenuButtons } from '../../shared/MenuButtons/MenuButtons';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { openModal } from '../../features/Modal/modal.slice';
import { useTranslation } from 'react-i18next';
import { useWebSocket } from '../../features/WebSocket/hooks/useWebSocket';
import { rootState } from '../../../redux/store';
import { useSendWebsocketMessage } from '../../features/WebSocket/hooks/useSendWebsocketMessage';
import { fetchScriptUpdateManagerPending } from '../../features/Datamanager/Inspector/ScriptSettings/scriptUpdate.slice';
import { ScriptUpdateCard } from '../../features/Datamanager/Inspector/ScriptSettings/scriptUpdateCard';
import { useMergedScripts } from '../../features/Datamanager/Inspector/ScriptSettings/hooks/useMergedScripts';

export const Header = () => {
    const { socketRef, isReady } = useWebSocket('Header');
    const { sendWebsocketMessage } = useSendWebsocketMessage(socketRef);
    
    const {pathname} = useLocation();
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
    
    // console.log('pathname: ', pathname, pathname.includes('projects'));
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();

    const {
        mergedScripts, 
        scriptUpdateManagerData, 
        scriptUpdateWsData, 
        scriptUpdateManagerError, 
        scriptUpdateManagerLoading, 
        createScriptCards, 
        onReloadScripts,
        onUpdateScripts
    } = useMergedScripts(socketRef, isReady)

    const updates = createScriptCards.filter((scriptCardItem) => scriptCardItem.shouldUpdate).length;

    const handleClick = () => {
        window.open('https://inform.inpro-electric.de/login', '_blank', 'noopener,noreferrer');
    };

    const fetchScriptData = ()=>{
        if (userAndTokenData) {
            sendWebsocketMessage(JSON.stringify({
                parameter: "Script version",
                token: userAndTokenData?.token || '',
            }));

            dispatch(fetchScriptUpdateManagerPending({
                url:`${ROUTES.GIT_VERSION}`,
                token: userAndTokenData?.token || '',
            }))
        }
    }

    useEffect(()=>{
        if(isReady){
            fetchScriptData();
        }
    },[isReady])
    

    const onScriptUpdate = ()=>{
        dispatch(openModal("scriptSettingsModal")); 
        fetchScriptData();
    } 



    return (
        <>
            <MenuButtons setShowMenu={setShowMenu} showMenu={showMenu} hasTop hasRight top={54} right={10}>
                <ExecButton stretch iconSize={1.6}  isDisabled={false} size="m" label={'Scripts update'} showLabel={true} iconName={'Scripts'} func={onScriptUpdate} />
                <ExecButton stretch iconSize={1.6} isDisabled={false} size="m" label={'Features config'} iconName={'Configure'} func={() => dispatch(openModal("configureModal"))} />
            </MenuButtons>

            <header className="header">
                <div className="header__logo-box">
                    <img className="header__logo-box--logo" src={ImProLogo} alt="impro-logo" />
                </div>
                {
                    !pathname.includes(ROUTES.PROJECTS) && !pathname.includes(ROUTES.PROJECT_ADMIN_COFIGURATION)
                    &&
                    <div className='animation'>
                        <Navbar />
                    </div>
                }
                <FlexCenter position="center" direction="v">
                    <LanguageSelect />
                    <ExecButton link textColor="grey-dark" weight={500} label={'InForm'} iconSize={1.6} iconName={'InForm_Icon_grey'} func={() => handleClick()} />
                    <UserInfo />
                        <SpacingCustom paddingRight={1}>
                    {
                        !pathname.includes(ROUTES.PROJECTS) && !pathname.includes(ROUTES.PROJECT_ADMIN_COFIGURATION)
                        &&
                            <ExecButton hasBadge hasBorder = {false} badgeValue={updates} isDisabled={false} size="l" label={''} showLabel={false} iconName={'ChatBotOptions'} func={() => setShowMenu(!showMenu)}/>
                        }
                        </SpacingCustom>
                </FlexCenter>
            </header>
        </>
    );
};
